import { render, staticRenderFns } from "./SummaryTabs.vue?vue&type=template&id=bb492322&scoped=true&"
import script from "./SummaryTabs.vue?vue&type=script&lang=js&"
export * from "./SummaryTabs.vue?vue&type=script&lang=js&"
import style0 from "./SummaryTabs.vue?vue&type=style&index=0&id=bb492322&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bb492322",
  null
  
)

export default component.exports